module.exports = __webpack_public_path__ + "static/media/icon_plate.7c7f9182.png";